// Katalog tablosunun "Gösterge" hücresi (katalog UX dalgası K1, 2026-11-03): etiket TEK satır —
// `white-space: nowrap` + üç nokta kırpma, tam ad `title`'da; gösterge kodu artık burada DEĞİL (ayrı
// "Kod" sütunu). Rozetler (ƒx, kırılım, kategori yaprak sayısı, kullanımdan kalktı) etiketten sonra
// küçülmeyen sarmalayıcıda; kırılım rozeti uzunsa kendi içinde kırpılır. ≤1100 px'te paket rozetleri
// adın altına iner (`.kpi-catalog-pkg-under`). Satır türü biçimi (DR8/DR14): kategori kalın, toplam
// 0.85rem·700, grup ince 0.75rem·600 text-3, üye normal.

import type { CSSProperties } from "react";
import type { KpiMetric } from "@mahir/shared";
import type { PackageBadges } from "../../lib/kpi-catalog-packages";
import { CatalogPackageBadges } from "./CatalogPackageBadges";
import { pillStyle, tdStyle } from "./kpi-form-styles";

export const catalogLabelEllipsis: CSSProperties = {
  minWidth: 0,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

function labelStyle(kind: string, isCategory: boolean, depth: number): CSSProperties {
  if (kind === "breakdown_group")
    return { fontSize: "0.75rem", fontWeight: 600, color: "var(--color-text-3)" };
  if (kind === "total") return { fontSize: "0.85rem", fontWeight: 700, color: "var(--color-text)" };
  return { fontWeight: isCategory ? (depth === 0 ? 700 : 600) : 400 };
}

export function CatalogNameCell(props: {
  metric: KpiMetric;
  /** satır türü (`data-row-kind`): shared satır türü, üye için "member" */
  kind: string;
  /** kategori bandı satırı (çocuklu ∧ toplam/grup değil) */
  isCategory: boolean;
  depth: number;
  /** aç/kapa düğmesi (kategori + toplam); null = yer tutucu */
  toggle: { open: boolean; onToggle: () => void } | null;
  /** kırılım rozeti metni ("kırılım: cinsiyet (2) · …") */
  pill: string | null;
  /** kategori yaprak sayısı */
  leafCount: number | null;
  badges: PackageBadges | null;
}): JSX.Element {
  const { metric: m, kind, isCategory, depth, toggle, pill, leafCount, badges } = props;
  const deprecated = m.status === "deprecated";
  return (
    <td style={{ ...tdStyle, paddingLeft: 12 + depth * 22 }}>
      <div
        className="flex items-center gap-1"
        style={{ minWidth: 0, flexWrap: "nowrap", overflow: "hidden" }}
      >
        {toggle ? (
          <button
            type="button"
            aria-label={toggle.open ? "Kapat" : "Aç"}
            aria-expanded={toggle.open}
            onClick={(e) => {
              e.stopPropagation();
              toggle.onToggle();
            }}
            style={{
              flexShrink: 0,
              border: 0,
              background: "transparent",
              width: 22,
              minHeight: 28,
              cursor: "pointer",
              color: "var(--color-text-2)",
            }}
          >
            {toggle.open ? "▾" : "▸"}
          </button>
        ) : (
          <span style={{ width: 22, flexShrink: 0 }} aria-hidden="true" />
        )}
        <span
          style={{ ...labelStyle(kind, isCategory, depth), ...catalogLabelEllipsis }}
          title={m.label}
          data-row-kind={kind}
        >
          {m.label}
        </span>
        <span
          className="flex items-center gap-1"
          data-testid="kpi-catalog-name-badges"
          style={{ flexShrink: 0, maxWidth: "60%", minWidth: 0 }}
        >
          {pill ? (
            <span
              data-testid="kpi-catalog-breakdown-pill"
              title={pill}
              style={{ fontSize: "0.75rem", color: "var(--color-text-3)", ...catalogLabelEllipsis }}
            >
              {pill}
            </span>
          ) : null}
          {m.isDerived ? (
            <span style={{ ...pillStyle, flexShrink: 0 }} title="Hesaplanan gösterge">
              ƒx
            </span>
          ) : null}
          {leafCount !== null ? (
            <span
              className="text-xs"
              style={{ color: "var(--color-text-3)", flexShrink: 0, whiteSpace: "nowrap" }}
            >
              · {leafCount}
            </span>
          ) : null}
          {deprecated ? (
            <span
              style={{
                ...pillStyle,
                flexShrink: 0,
                whiteSpace: "nowrap",
                background: "var(--color-bg)",
                color: "var(--color-text-2)",
              }}
            >
              kullanımdan kalktı
            </span>
          ) : null}
        </span>
      </div>
      {badges && badges.all.length > 0 ? (
        <span className="kpi-catalog-pkg-under" style={{ marginTop: 4 }}>
          <CatalogPackageBadges badges={badges} metricLabel={m.label} />
        </span>
      ) : null}
    </td>
  );
}
